import { Text, TextProps } from '@sternum/web/components/Text';

export function Title({ children, ...props }: TextProps) {
  return (
    <Text
      color={{ Light: 'DarkerText', Dark: 'DarkerText' }}
      size={20}
      weight={500}
      aria-label="app header title"
      {...props}
    >
      {children}
    </Text>
  );
}
